<template>
  <div class="content flex my-4">
    <div class="auth-form mx-auto my-auto">
      <div class="card">
        <div class="card-body">
          <h1 class="heading-big mb-4">
            {{ $t('resetPassword.resetPass') }}
          </h1>
          <f-alert
            v-if="authError"
            theme="danger"
            visible
            class="my-5">
            <template v-if="errorText">
              {{ errorText }}
            </template>
            <template v-else>
              {{ $t('forgotPassword.errorAuth') }}
            </template>
          </f-alert>

          <validation-observer
            ref="password-reset-form"
            tag="form">
            <validation-provider
              rules="email"
              name="email"
              v-slot="{ errors }">
              <div class="form-group">
                <label>{{ $t('user.emailAddress') }}</label>
                <f-input
                  :disabled="true"
                  v-model="email"
                  name="email"
                  type="email"
                  class="full-width"
                  :state="errors.length ? 'invalid' : null"
                  :placeholder="$t('resetPassword.yourEmail')" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </div>
            </validation-provider>

            <div class="form-group">
              <label for="password">
                {{ $t('user.password') }}:
              </label>

              <validation-provider
                rules="required|min:8"
                name="password"
                v-slot="{ errors }">
                <f-input
                  v-model="password"
                  type="password"
                  :state="errors.length ? 'invalid' : null"
                  :placeholder="$t('resetPassword.yourNewPassword')" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>

            <div class="form-group">
              <label for="password-confirmation">
                {{ $t('user.repeatPassword') }}:
              </label>

              <validation-provider
                :rules="'required|min:8|password:password'"
                name="password-confirmation"
                v-slot="{ errors }">
                <f-input
                  v-model="password_confirmation"
                  type="password"
                  :state="errors.length ? 'invalid' : null"
                  :placeholder="$t('resetPassword.yourNewPassword')" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>

            <input
              type="hidden"
              :value="token" />

            <f-button
              type="submit"
              theme="primary"
              class="full-width mt-1"
              big
              withArrow
              @click.prevent="submit"
              :disabled="submitting">
              {{ $t('user.savePassword') }}
            </f-button>
          </validation-observer>

          <div class="text-center mt-4">
            <router-link
              to="/logowanie"
              class="lnk lnk-big lnk-big-blue"
              :disabled="submitting">
              {{ $t('ui.backToLoginPage') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'PasswordReset',
  computed: {
    email () {
      if (this.$route.query && this.$route.query.email) {
        return this.$route.query.email;
      }

      Vue.set(this, 'authError', true);
      Vue.set(this, 'errorText', this.$t('resetPassword.linkPasswordIncorrect'));

      return ''
    },
    token () {
      if (this.$route.params && this.$route.params.token) {
        return this.$route.params.token;
      }

      Vue.set(this, 'authError', true);
      Vue.set(this, 'errorText', this.$t('resetPassword.linkPasswordIncorrect'));

      return ''
    }
  },
  data () {
    return {
      authError: false,
      submitting: false,
      errorText: '',
      password: '',
      password_confirmation: '',
    }
  },
  methods: {
    submit () {
      this.submitting = true;
      this.authError = false;

      let resetParams = {
        email: this.email,
        password: this.password,
        password_confirmation: this.password_confirmation,
        token: this.token,
      };

      this.$http.post('/api/auth/password/reset', resetParams).then((response) => {
        this.submitting = false;

        if (!response.data.success) {
          this.authError = true;
          this.errorText = response.data.message;
        } else {
          this.$router.push('/logowanie/haslo-zmienione');
        }
      }).catch((error) => {
        console.log(error);
        this.submitting = false;
        this.authError = true;
      });
    }
  }
}
</script>
